<template>
  <div>
    <tabs :tabs="listTab"></tabs>
  </div>
</template>

<script>
import Tabs from "./Components/Tabs";
import Settings from "./Settings";
import ProgressReportPage from "./ProgressReports";
import SubmittedReport from "./SubmittedReport";
import CensorSubmittedReport from "./CensorSubmittedReport";
import { mapActions, mapGetters } from "vuex";
import { ProgressReport } from "@/constants/Permissions";
import Role from "@/constants/Role";
import { hasValidRole } from "@/helpers/role-helper";

export default {
  components: { Tabs },
  data() {
    return {
      listTab: []
    };
  },
  computed: {
    ...mapGetters("user", { userInfo: "info", userRole: "role" }),
    authorized() {
      return this.userInfo?.inputterOrReviewDetail?.authorized;
    },
    typeSendingMode() {
      return this.userInfo?.inputterOrReviewDetail?.type_sending_model;
    }
  },
  watch: {
    authorized: function() {
      this.setListTab();
    },
    typeSendingMode: function() {
      this.setListTab();
    }
  },
  created() {
    this.setListTab();
    this.getStudentAssigned();
  },
  methods: {
    ...mapActions("user", ["getStudentAssigned"]),
    setListTab() {
      let tabs = [];
      const sendingMode = this.typeSendingMode || "No-review";
      //setting
      if (
        hasValidRole(this.userRole, [Role.Admin, Role.Principal]) ||
        this.$can(ProgressReport.actions.setting, ProgressReport.subject)
      ) {
        tabs.push({
          name: "progress-settings",
          label: "progress_report.settings",
          component: Settings
        });
      }
      //progress report
      if (this.authorized === "Inputter" || [Role.Admin, Role.Principal]) {
        tabs.push({
          name: "progress-report",
          label: "progress_report.progress_report",
          component: ProgressReportPage
        });
      }
      if (sendingMode === "No-review") {
        this.listTab = tabs;
        return;
      }
      //submited report
      if (
        this.authorized === "Inputter" ||
        this.$can(
          ProgressReport.actions.submittedReport,
          ProgressReport.subject
        )
      ) {
        tabs.push({
          name: "submitted-report",
          label: "progress_report.submitted_report",
          component: SubmittedReport
        });
      }
      //sensor submited report
      if (
        this.authorized === "Review" ||
        this.$can(
          ProgressReport.actions.censorSubmittedReport,
          ProgressReport.subject
        )
      ) {
        tabs.push({
          name: "censor-submitted-report",
          label: "progress_report.censor_submitted_report",
          component: CensorSubmittedReport
        });
      }
      this.listTab = tabs;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine";

.tab-button {
  @apply py-2 px-4;
  @apply text-gray-500 font-medium;
  @apply cursor-pointer;
  @apply outline-none;

  font-size: 1rem;

  &.active {
    border-top: 2px solid md-get-palette-color(purple, 500);
  }
}
</style>
